import { displayDateFormatter } from "components/helpers";

const DictationSummary = ({ params }) => {
  console.log("params: ", params);
  if (!params) return <div>No data available</div>; // Quick check for params

  const {
    practice_name = "",
    address_line1 = "",
    address_line2 = "",
    city = "",
    phone = "",
    fax = "",
    tax_id = "",
  } = params?.practice_details || {}; // Default empty objects if missing

  return (
    <div className="print-dictation-form" id="my_invoice">
      <div className="header">
        <div className="practice_details">
          <p className="practice_name">{practice_name}</p>
          <p className="practice_address">{address_line1}</p>
          <p className="practice_address">{address_line2}</p>
          <p className="practice_address">{city}</p>
          <p className="practice_phone">
            Tel. {phone} / Fax {fax}
          </p>
          <p className="practice_tax_id">Tax Id {tax_id}</p>
        </div>
      </div>
      <div className="patient-details">
        <p>
          <b>NAME</b>: {params.patient_details?.first_name}{" "}
          {params.patient_details?.last_name}
        </p>
        <p>
          <b>DATE OF BIRTH</b>:{" "}
          {displayDateFormatter(params.patient_details?.dob)}
        </p>
        <p>
          <b>DATE OF EVALUATION</b>: {displayDateFormatter(params.dos)}
        </p>
        <p>
          <b>REFERRING PHYSICIAN</b>: {params.encounter_date}
        </p>
      </div>
      <br />
      <div className="patient-details">
        {params?.notes?.map((note, index) => (
          <div key={index}>
            <p className="patient_history">
              <b>{note.note_category}</b>:{" "}
              <div
                className="patient_history_text"
                dangerouslySetInnerHTML={{ __html: note.note_text }}
              />
            </p>
            <br />
          </div>
        ))}
      </div>
      <div className="closingStatement">
        <p>Thank you for allowing me to evaluate this patient.</p>
        <br />
        <p>Sincerely,</p>
        <br />
        <div>
          <p>
            <b>{practice_name}</b>
          </p>
          <p>
            <b>{address_line1}</b>
          </p>
          <p>
            <b>{address_line2}</b>
          </p>
          <p>
            <b>{city}</b>
          </p>
          <p>
            <b>
              Tel. {phone} / Fax {fax}
            </b>
          </p>
          <p>
            <b>Tax Id {tax_id}</b>
          </p>
        </div>
      </div>
    </div>
  );
};

export default DictationSummary;
